var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table dre-gerencial-table mb-0"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "categoria-col"
  }, [_vm._v("Categoria")]), _vm._l(_vm.periods, function (period) {
    return _c('th', {
      key: period,
      staticClass: "text-right value-col",
      class: {
        'current-period': _vm.isCurrentPeriod(period)
      }
    }, [_vm._v(" " + _vm._s(_vm.formatPeriodHeader(period)) + " ")]);
  }), _c('th', {
    staticClass: "text-right value-col"
  }, [_vm._v("Total")])], 2)]), _c('tbody', [_vm._l(_vm.linhas, function (linha, index) {
    return [linha.tipo === 'secao' ? [_c('tr', {
      key: "secao-".concat(index),
      staticClass: "row-secao"
    }, [_c('td', [_c('span', {
      staticClass: "icon-circle mr-1",
      class: linha.sinal === 1 ? 'icon-positive' : 'icon-negative'
    }, [_vm._v(" " + _vm._s(linha.sinal === 1 ? "⊕" : "⊖") + " ")]), _c('strong', [_vm._v(_vm._s(linha.descricao))])]), _vm._l(_vm.periods, function (period) {
      return _c('td', {
        key: period,
        staticClass: "text-right",
        class: {
          'current-period': _vm.isCurrentPeriod(period)
        }
      }, [_c('strong', {
        class: linha.sinal === 1 ? 'text-success' : 'text-danger'
      }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.getBalance(linha.balances, period))) + " ")])]);
    }), _c('td', {
      staticClass: "text-right"
    }, [_c('strong', {
      class: linha.sinal === 1 ? 'text-success' : 'text-danger'
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(linha.total)) + " ")])])], 2), _vm._l(linha.planos, function (plano) {
      return _c('tr', {
        key: "plano-".concat(plano.id),
        staticClass: "row-plano"
      }, [_c('td', {
        staticClass: "plano-descricao",
        class: plano.tipo === 2 ? 'border-left-positive' : 'border-left-negative'
      }, [_vm._v(" " + _vm._s(plano.descricao) + " ")]), _vm._l(_vm.periods, function (period) {
        return _c('td', {
          key: period,
          staticClass: "text-right",
          class: {
            'current-period': _vm.isCurrentPeriod(period)
          }
        }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.getBalance(plano.balances, period))) + " ")]);
      }), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.planoTotal(plano.balances))) + " ")])], 2);
    })] : linha.tipo === 'subtotal' ? _c('tr', {
      key: "subtotal-".concat(index),
      staticClass: "row-subtotal"
    }, [_c('td', [_c('span', {
      staticClass: "icon-subtotal mr-1"
    }, [_vm._v("=")]), _c('strong', [_vm._v(_vm._s(linha.descricao))])]), _vm._l(_vm.periods, function (period) {
      return _c('td', {
        key: period,
        staticClass: "text-right",
        class: {
          'current-period': _vm.isCurrentPeriod(period)
        }
      }, [_c('strong', {
        class: _vm.valueClass(_vm.getBalance(linha.balances, period))
      }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.getBalance(linha.balances, period))) + " ")])]);
    }), _c('td', {
      staticClass: "text-right"
    }, [_c('strong', {
      class: _vm.valueClass(linha.total)
    }, [_vm._v(" " + _vm._s(_vm.formatCurrency(linha.total)) + " ")])])], 2) : _vm._e()];
  })], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };